import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'

import styles from './index.module.scss'
import BottomBar from './components/BottomBar'
import TopHeader from './components/TopHeader'
import ViewCart from './components/ViewCart'
import PopUpTopPage from '~/components/PopUpTopPage'

const cx = classNames.bind(styles)

// Tablet layout dùng chung cho tất cả các màn hình
const TabletLayout = ({ children }) => {
  return (
    <>
      <PopUpTopPage />
      <div className={cx('container')}>
        {/* View bên trái */}
        <div className={cx('left_view')}>
          {/* Main */}
          <main className={cx('main_content')}>{children}</main>

          {/* Bottom bar */}
          <div className={cx('bottom_bar')}>
            <BottomBar />
          </div>
        </div>
        {/* View bên phải */}
        <aside className={cx('right_view')}>
          {/* Top header */}
          <header className={cx('header')}>
            <TopHeader />
          </header>

          {/* Cart */}
          <section className={cx('view_cart')}>
            <ViewCart />
          </section>
        </aside>
      </div>
    </>
  )
}

TabletLayout.propTypes = {
  children: PropTypes.node,
}

export default TabletLayout
